import FocusableIconButton from '@components/FocusableIconButton';
import { usePatientSelectionContext } from '@context/PatientSelection';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';

import { NEW_USER } from '../../../focuskey';
import ExistingUsers from '../ExistingUsers';

import * as styles from './styles';

const ButtonContainer = () => {
  const { patients, goAddNewUser } = usePatientSelectionContext();
  const { ref, focusKey } = useFocusable();
  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} css={styles.buttonContainer}>
        {patients && patients.length > 0 && (
          <div css={styles.existingUserButtons}>
            <p css={styles.buttonTitle}>등록된 사용자</p>
            <ExistingUsers />
          </div>
        )}
        <div css={styles.newUserButton}>
          <FocusableIconButton
            focusKey={NEW_USER}
            onEnterPress={goAddNewUser}
            iconType="plus"
          >
            새로운 사용자 등록하기
          </FocusableIconButton>
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default ButtonContainer;
